import React, { useState, useEffect } from 'react';
import './Toast.css';

let toastId = 0;
const toasts = [];
const listeners = [];

// Toast管理器
const ToastManager = {
  subscribe(callback) {
    listeners.push(callback);
    return () => {
      const index = listeners.indexOf(callback);
      if (index > -1) listeners.splice(index, 1);
    };
  },
  
  notify(message, type = 'info', duration = 3000) {
    const id = ++toastId;
    const toast = { id, message, type, duration };
    toasts.push(toast);
    listeners.forEach(callback => callback([...toasts]));
    
    if (duration > 0) {
      setTimeout(() => {
        this.remove(id);
      }, duration);
    }
    
    return id;
  },
  
  remove(id) {
    const index = toasts.findIndex(t => t.id === id);
    if (index > -1) {
      toasts.splice(index, 1);
      listeners.forEach(callback => callback([...toasts]));
    }
  },
  
  success(message, duration = 3000) {
    return this.notify(message, 'success', duration);
  },
  
  error(message, duration = 4000) {
    return this.notify(message, 'error', duration);
  },
  
  info(message, duration = 3000) {
    return this.notify(message, 'info', duration);
  },
  
  warning(message, duration = 3000) {
    return this.notify(message, 'warning', duration);
  },
};

// Toast容器组件
export const ToastContainer = () => {
  const [toastList, setToastList] = useState([]);
  
  useEffect(() => {
    const unsubscribe = ToastManager.subscribe(setToastList);
    return unsubscribe;
  }, []);
  
  return (
    <div className="toast-container">
      {toastList.map(toast => (
        <div
          key={toast.id}
          className={`toast toast-${toast.type}`}
          onClick={() => ToastManager.remove(toast.id)}
        >
          <div className="toast-icon">
            {toast.type === 'success' && '✓'}
            {toast.type === 'error' && '✕'}
            {toast.type === 'warning' && '⚠'}
            {toast.type === 'info' && 'ℹ'}
          </div>
          <div className="toast-message">{toast.message}</div>
          <button className="toast-close" onClick={() => ToastManager.remove(toast.id)}>×</button>
        </div>
      ))}
    </div>
  );
};

// 导出Toast管理器
export default ToastManager;

